import React from 'react';
import { graphql } from 'gatsby';
//@ts-ignore
import * as styles from './blog-content-rendering.module.css';
import RichText from '../Global/RichText';
//@ts-ignore
import {
    KontentRichText,
    KontentStringValue,
    KontentRadioMultiChoice,
} from '../../../types/KontentProps';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { getMultiChoice } from '../Global/DataUtils';

interface Props {
    kontentItemId?: string;
    content?: KontentRichText;
    content_alignment?: KontentRadioMultiChoice<'right' | 'left' | 'center'>;
    control_top_margin?: KontentRadioMultiChoice<'yes' | 'no'>;
    desktop_top_margin?: KontentStringValue;
    mobile_top_margin?: KontentStringValue;
    anchor?: KontentStringValue;
}

const BlogContentRendering: React.FC<Props> = ({
    kontentItemId,
    content,
    content_alignment,
    control_top_margin,
    desktop_top_margin,
    mobile_top_margin,
    anchor,
}) => {
    if (!content?.value) return null;
    const breakpoints = useBreakpoint();
    const contentAlignment = getMultiChoice(content_alignment);
    const controlTopMargin = getMultiChoice(control_top_margin);
    const topMargin =
        controlTopMargin &&
        desktop_top_margin?.value &&
        mobile_top_margin?.value
            ? breakpoints.md
                ? desktop_top_margin?.value
                : mobile_top_margin?.value
            : '';
    return (
        <section
            id={anchor?.value || undefined}
            className={styles.wrapper}
            data-kontent-item-id={kontentItemId}
            style={{
                textAlign: contentAlignment || undefined,
                marginTop: topMargin ? `${topMargin}px` : undefined,
            }}
        >
            {RichText(content, false, undefined, undefined, 'content')}
        </section>
    );
};
export default BlogContentRendering;

export const fragmentBlogContent = graphql`
    fragment BlogContent on kontent_item_component___blog_content {
        elements {
            content {
                ...kontentRichText
            }
            desktop_top_margin {
                value
            }
            mobile_top_margin {
                value
            }
            control_top_margin {
                value {
                    codename
                }
            }
            content_alignment {
                value {
                    codename
                }
            }
            anchor {
                value
            }
        }
    }
`;
